import React from 'react';
import Select from 'react-select';

interface Option {
  value: string;
  label: string;
}

interface ComboBoxProps {
  name: string,
  placeHolder: string;
  options: Option[];
  onChange: (selectedOption: Option | null) => void;
  porDefecto: Option | null
}

export default function ComboBox(props: ComboBoxProps){
    return (
        <Select
          options={props.options}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          name={props.name}
          defaultValue={props.porDefecto}
        />
      );
}